import { LOGS_PATH } from 'installations/navigation';

const indexComponent = require('./routes/index/components/InstallationLogsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: LOGS_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationLogs'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/logs/index.js